import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Ramp } from 'src/app/admin/models/ramp.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RampService } from 'src/app/admin/services/ramp.service';
import { validateRamp, validateRoom } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-edit-ramp-modal',
  templateUrl: './edit-ramp-modal.component.html',
  styleUrls: ['./edit-ramp-modal.component.scss'],
})
export class EditRampModalComponent implements OnInit {
 ramp:Ramp;
 errMsg = '';
 brojRampe:string;
 ulazna:boolean;
 izlazna:boolean;

  playrooms$ = this.roomService.playrooms$; 
  ramp$=this.rampService.ramp$;
  constructor(private modalController: ModalController,private roomService: PlayroomService, private rampService: RampService, private router:Router ) { }

  ngOnInit() {
    this.roomService.getAllPlayrooms(); 
    console.log("ramp");
   
    this.ramp.roomId = this.ramp['room']?.id;
 /*  this.ramp.roomName= this.ramp[0].roomName; */
  console.log(this.ramp);
  }
  
  editRamp() {
    const formValidation = validateRamp(this.ramp);
    this.errMsg = formValidation.errMsg;
    if(formValidation.isValid) {
      this.rampService.editRamp(this.ramp).subscribe(res => {
        this.rampService.getAllRamp({currentPage: 1, itemsPerPage: 100,
          ulaznaQuery: '', izlaznaQuery: '', brojRampeQuery: '',roomNameQuery:'',StatusQuery:''});
        this.dismissModal();
      },(err) => {
        console.error(err);
      });
    }
  }
 dismissModal() {
    this.modalController.dismiss();
  }
}
